"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LegendKeys = require("../LegendKeys");

var _colors = require("../../constants/colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AllLegend = function AllLegend(_ref) {
  var hasBattery = _ref.hasBattery,
      hasCT = _ref.hasCT;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_LegendKeys.ChartLegend, {
    backgroundColor: _colors.SOLAR
  }, "Solar"), hasBattery && /*#__PURE__*/_react["default"].createElement(_LegendKeys.ChartLegend, {
    backgroundColor: _colors.SYSTEM_PRODUCTION
  }, "System Production"), /*#__PURE__*/_react["default"].createElement(_LegendKeys.ChartLegend, {
    backgroundColor: _colors.PEER_ADJ
  }, "Peer"), /*#__PURE__*/_react["default"].createElement(_LegendKeys.ChartLegend, {
    backgroundColor: _colors.CONTRACTED
  }, "Contracted"), hasBattery && /*#__PURE__*/_react["default"].createElement(_LegendKeys.BatteryChartLegend, null), hasCT && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_LegendKeys.ChartLegend, {
    backgroundColor: _colors.WHITE,
    color: _colors.CONSUMPTION
  }, "Self Consumption"), /*#__PURE__*/_react["default"].createElement(_LegendKeys.ChartLegend, {
    backgroundColor: _colors.CONSUMPTION
  }, "Consumption"), /*#__PURE__*/_react["default"].createElement(_LegendKeys.ChartLegend, {
    backgroundColor: _colors.EXPORT,
    color: _colors.WHITE
  }, "Export")));
};

AllLegend.propTypes = {
  hasBattery: _propTypes["default"].bool.isRequired,
  hasCT: _propTypes["default"].bool.isRequired
};
var _default = AllLegend;
exports["default"] = _default;